
import * as api from "../constant/NewAPI";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../router/all_routes";
import Select from "react-select";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import * as XLSX from "xlsx";
import Utils from "../constant/Utils";

// import * as api from "../constant/API";

const InstitutesFilteredBySport = () => {

    const routes = all_routes;

    const [searchInput, setSearchInput] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [sportId, setSportId] = useState('');
    const [sportList, setSportList] = useState([]);
    const [reportList, setReportList] = useState([]);
    const [showTable, setShowTable] = useState(false);

    useEffect(() => {
        getSportsTypeList();
    }, [])

    function getSportsTypeList() {
        const sprtTypLst = api.SportsTypeList;
        fetch(sprtTypLst, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((sprtResponse) => sprtResponse.json())
            .then((sprtResult) => {
                if (sprtResult.error == true) {
                    if (sprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setSportList(sprtResult.data)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch sport list", error)
            })
    }

    function sportReport() {
        const rprt = api.GetInstitutionSportsData + '/' + sportId //"?sportsTypeId=" + sportId;
        fetch(rprt, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            }
        })
            .then((rprtResponse) => rprtResponse.json())
            .then((rprtResult) => {
                if (rprtResult.error == true) {
                    if (rprtResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    setReportList(rprtResult.data)
                    setShowTable(true)
                }
            })
            .catch((error) => {
                console.log("Failed to fetch institiute report filtered by sport", error)
            })
    }

    function exportnow() {
        const formData = new FormData();
        formData.append('sportsTypeId', sportId);
        const sporttoexcel = api.SportsNameExportToExcel;
        fetch(sporttoexcel, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData,
        })
            .then((excelResponse) => excelResponse.json())
            .then((excelResult) => {
                if (excelResult.error == true) {
                    if (excelResult.code == 401) {
                        Utils.logoutUser();
                    }
                } else {
                    // exportToExcel(excelResult)
                    const blob = new Blob([excelResult.data], { type: "application/vnd.ms-excel" });
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = "InstitutesFilteredBySport.xls"; // Save file as .xls
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    URL.revokeObjectURL(url);
                }
            })
            .catch((error) => {
                console.log("Failed to export the report", error)
            })
    }

    // function exportToExcel(htmlString) {
    //     // Create a new workbook and worksheet
    //     const workbook = XLSX.utils.book_new();

    //     // Create a DOM parser to parse the HTML
    //     const parser = new DOMParser();
    //     const doc = parser.parseFromString(htmlString, 'text/html');

    //     // Extract the table from the HTML
    //     const table = doc.querySelector('table');

    //     if (table) {
    //         // Convert the HTML table to a worksheet
    //         const worksheet = XLSX.utils.table_to_sheet(table);

    //         // Prepare to insert the title
    //         const title = "Sports By Institute";
    //         const colCount = Object.keys(worksheet).filter(cell => cell.match(/^[A-Z]+1$/)).length;

    //         // Shift existing data down by one row
    //         const dataRange = XLSX.utils.decode_range(worksheet['!ref']);
    //         for (let R = dataRange.e.r; R >= dataRange.s.r; R--) {
    //             for (let C = dataRange.s.c; C <= dataRange.e.c; C++) {
    //                 const oldCell = XLSX.utils.encode_cell({ r: R, c: C });
    //                 const newCell = XLSX.utils.encode_cell({ r: R + 1, c: C });
    //                 if (worksheet[oldCell]) {
    //                     worksheet[newCell] = worksheet[oldCell];
    //                     delete worksheet[oldCell];
    //                 }
    //             }
    //         }

    //         // Set the title in the first row
    //         worksheet['A1'] = { t: 's', v: title };
    //         worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }];
    //         worksheet['A1'].s = {
    //             font: { sz: 18, bold: true },
    //             alignment: { horizontal: 'center', vertical: 'center' },
    //             border: {
    //                 top: { style: 'thin', color: { rgb: '000000' } },
    //                 bottom: { style: 'thin', color: { rgb: '000000' } },
    //                 left: { style: 'thin', color: { rgb: '000000' } },
    //                 right: { style: 'thin', color: { rgb: '000000' } },
    //             }
    //         };

    //         // Apply formatting to header cells
    //         const headerRow = 1; // Header row index (1-based)
    //         for (let C = dataRange.s.c; C <= dataRange.e.c; C++) {
    //             const headerCell = XLSX.utils.encode_cell({ r: headerRow, c: C });
    //             if (worksheet[headerCell]) {
    //                 worksheet[headerCell].s = {
    //                     font: { bold: true },
    //                     border: {
    //                         top: { style: 'thin', color: { rgb: '000000' } },
    //                         bottom: { style: 'thin', color: { rgb: '000000' } },
    //                         left: { style: 'thin', color: { rgb: '000000' } },
    //                         right: { style: 'thin', color: { rgb: '000000' } },
    //                     }
    //                 };
    //             }
    //         }

    //         // Add borders to all other cells
    //         for (let row = 1; row <= dataRange.e.r; row++) {
    //             for (const col in worksheet) {
    //                 if (col.match(/^[A-Z]+\d+$/)) {
    //                     const cellRef = col;
    //                     if (worksheet[cellRef] && !worksheet[cellRef].s) {
    //                         worksheet[cellRef].s = {
    //                             border: {
    //                                 top: { style: 'thin', color: { rgb: '000000' } },
    //                                 bottom: { style: 'thin', color: { rgb: '000000' } },
    //                                 left: { style: 'thin', color: { rgb: '000000' } },
    //                                 right: { style: 'thin', color: { rgb: '000000' } },
    //                             }
    //                         };
    //                     }
    //                 }
    //             }
    //         }

    //         // Adjust the row height for the title
    //         worksheet['!rows'] = [{ hpx: 30 }, ...Array.from({ length: dataRange.e.r - dataRange.s.r + 1 }, () => ({}))];

    //         // Adjust column widths
    //         const colWidths = XLSX.utils.sheet_to_json(worksheet, { header: 1 }).reduce((widths, row) => {
    //             return row.map((value, i) => {
    //                 const width = value ? value.toString().length : 10; // 10 is a default minimum width
    //                 return Math.max(widths[i] || 10, width);
    //             });
    //         }, []);

    //         worksheet['!cols'] = colWidths.map(w => ({ wch: w + 1 })); // Adding some padding

    //         // Add the worksheet to the workbook
    //         XLSX.utils.book_append_sheet(workbook, worksheet, 'Sport By Institute');

    //         // Generate Excel file and trigger download
    //         XLSX.writeFile(workbook, 'SportByInstitute.xlsx');
    //     } else {
    //         console.error('Table not found in the HTML string.');
    //     }
    // }

    function exportToExcel(htmlString) {
        // Create a new workbook and worksheet
        const workbook = XLSX.utils.book_new();

        // Create a DOM parser to parse the HTML
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlString, 'text/html');

        // Extract the table from the HTML
        const table = doc.querySelector('table');

        if (table) {
            // Convert the HTML table to a worksheet
            const worksheet = XLSX.utils.table_to_sheet(table);

            // Prepare to insert the title
            const title = "Sport By Institute";
            const colCount = Object.keys(worksheet).filter(cell => cell.match(/^[A-Z]+1$/)).length;

            // Shift existing data down by one row
            const dataRange = XLSX.utils.decode_range(worksheet['!ref']);
            for (let R = dataRange.e.r; R >= dataRange.s.r; R--) {
                for (let C = dataRange.s.c; C <= dataRange.e.c; C++) {
                    const oldCell = XLSX.utils.encode_cell({ r: R, c: C });
                    const newCell = XLSX.utils.encode_cell({ r: R + 1, c: C });
                    if (worksheet[oldCell]) {
                        worksheet[newCell] = worksheet[oldCell];
                        delete worksheet[oldCell];
                    }
                }
            }

            // Update the worksheet range to include the new first row
            dataRange.e.r += 1;
            worksheet['!ref'] = XLSX.utils.encode_range(dataRange);

            // Set the title in the first row
            worksheet['A1'] = { t: 's', v: title };
            worksheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: colCount - 1 } }];
            worksheet['A1'].s = {
                font: { sz: 18, bold: true },
                alignment: { horizontal: 'center', vertical: 'center' },
                border: {
                    top: { style: 'thin', color: { rgb: '000000' } },
                    bottom: { style: 'thin', color: { rgb: '000000' } },
                    left: { style: 'thin', color: { rgb: '000000' } },
                    right: { style: 'thin', color: { rgb: '000000' } },
                }
            };

            // Apply formatting to header cells
            const headerRow = 1; // Header row index (1-based)
            for (let C = dataRange.s.c; C <= dataRange.e.c; C++) {
                const headerCell = XLSX.utils.encode_cell({ r: headerRow, c: C });
                if (worksheet[headerCell]) {
                    worksheet[headerCell].s = {
                        font: { bold: true },
                        border: {
                            top: { style: 'thin', color: { rgb: '000000' } },
                            bottom: { style: 'thin', color: { rgb: '000000' } },
                            left: { style: 'thin', color: { rgb: '000000' } },
                            right: { style: 'thin', color: { rgb: '000000' } },
                        }
                    };
                }
            }

            // Add borders to all other cells
            for (let row = 1; row <= dataRange.e.r; row++) {
                for (const col in worksheet) {
                    if (col.match(/^[A-Z]+\d+$/)) {
                        const cellRef = col;
                        if (worksheet[cellRef] && !worksheet[cellRef].s) {
                            worksheet[cellRef].s = {
                                border: {
                                    top: { style: 'thin', color: { rgb: '000000' } },
                                    bottom: { style: 'thin', color: { rgb: '000000' } },
                                    left: { style: 'thin', color: { rgb: '000000' } },
                                    right: { style: 'thin', color: { rgb: '000000' } },
                                }
                            };
                        }
                    }
                }
            }

            // Adjust the row height for the title
            worksheet['!rows'] = [{ hpx: 30 }, ...Array.from({ length: dataRange.e.r - dataRange.s.r + 1 }, () => ({}))];

            // Adjust column widths
            const colWidths = XLSX.utils.sheet_to_json(worksheet, { header: 1 }).reduce((widths, row) => {
                return row.map((value, i) => {
                    const width = value ? value.toString().length : 10; // 10 is a default minimum width
                    return Math.max(widths[i] || 10, width);
                });
            }, []);

            worksheet['!cols'] = colWidths.map(w => ({ wch: w + 1 })); // Adding some padding

            // Add the worksheet to the workbook
            XLSX.utils.book_append_sheet(workbook, worksheet, 'Sport By Institute');

            // Generate Excel file and trigger download
            XLSX.writeFile(workbook, 'SportByInstitute.xlsx');
        } else {
            console.error('Table not found in the HTML string.');
        }
    }


    const filteredData = reportList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const instituteRender = (rowData, column) => {
        return <span>{rowData.instaName}</span>
    };

    const coachRender = (rowData, column) => {
        return <span>{rowData.coachName}</span>
    };

    const sportRender = (rowData, column) => {
        return <span>{rowData.sportName}</span>
    };

    return (
        <>
            <div className="content container">
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row d-flex align-items-center">
                                <h3 className="text-center mb-40">
                                    <i className="fa fa-university"></i>
                                    Institute By Sports Report
                                </h3>
                            </div>
                            <div>
                                <Link
                                    to={routes.reports}
                                    className="btn btn-primary save-profile"
                                >
                                    <i className="fas fa-arrow-left"></i>Back
                                </Link>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="court-tab-content">
                                        <div className="court-tab-content">
                                            <div className="card card-tableset">
                                                <div className="card-body">
                                                    <div className="coache-head-blk">
                                                        <div className="row align-items-center">
                                                            <div className="row col-md-12">
                                                                <div className="row col-md-12 court-sortby sortbyset">
                                                                    <div className="col-md-4"></div>
                                                                    <div className="col-md-4">
                                                                        <div className="mb-10">
                                                                            <label className="sortbytitle"><h6>Select Sport</h6></label>
                                                                            <Select
                                                                                value={sportList.find(sprt => sprt.sportId === sportId) ? {
                                                                                    value: sportId,
                                                                                    label: sportList.find(sprt => sprt.sportId === sportId).sportName
                                                                                } : null}
                                                                                onChange={(e) => {
                                                                                    setSportId(e.value);
                                                                                }}
                                                                                options={sportList.map(sprt => ({
                                                                                    value: sprt.sportId,
                                                                                    label: sprt.sportName
                                                                                }))}>
                                                                            </Select>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4"></div>
                                                                    <div className="col-md-4"></div>
                                                                    <div className="col-md-4 text-center">
                                                                        <div className="save-changes text-sm mt-4">
                                                                            <Link
                                                                                to="#"
                                                                                className="btn btn-primary save-profile"
                                                                                onClick={sportReport}
                                                                            >
                                                                                Submit
                                                                            </Link>
                                                                            <Link
                                                                                to="#"
                                                                                className={`btn btn-primary save-profile`}
                                                                                onClick={exportnow}
                                                                            >
                                                                                Export to Excel
                                                                            </Link>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-md-4"></div>
                                                                </div>
                                                                {showTable && (
                                                                    <>
                                                                        <div className="col-md-12">
                                                                        </div>
                                                                        <div className="col-md-12">
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <div className="dataTables_filter">
                                                                                <label>
                                                                                    <input
                                                                                        type="text"
                                                                                        value={searchInput}
                                                                                        onChange={(e) => setSearchInput(e.target.value)}
                                                                                        placeholder="Search"
                                                                                        className="form-control"
                                                                                    />
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                        {showTable && (
                                                            <>
                                                                <div className="tab-content mt-2">
                                                                    <div
                                                                        className="tab-pane fade show active"
                                                                        id="nav-Recent"
                                                                        role="tabpanel"
                                                                        aria-labelledby="nav-Recent-tab"
                                                                        tabIndex={0}
                                                                    >
                                                                        <div className="table-responsive table-datatble">
                                                                            <DataTable
                                                                                className="table datatable"
                                                                                value={filteredData}
                                                                                paginator
                                                                                rows={10}
                                                                                rowsPerPageOptions={[10, 25, 50, 100]}
                                                                                // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                                                                pageLinkSize={3}
                                                                            >
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="slNo"
                                                                                    body={slNoRender}
                                                                                    header="Sl No"
                                                                                // headerStyle={{ backgroundColor: "#0f2a4e", color: "#FFFF" }}
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="instaName"
                                                                                    body={instituteRender}
                                                                                    header="Institute"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="coachName"
                                                                                    body={coachRender}
                                                                                    header="Coach"
                                                                                ></Column>
                                                                                <Column
                                                                                    sortable
                                                                                    headerClassName="text-uppercase"
                                                                                    field="sportName"
                                                                                    body={sportRender}
                                                                                    header="Sport"
                                                                                ></Column>
                                                                            </DataTable>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InstitutesFilteredBySport;